import styled from 'styled-components';

const OtpPageWrapper = styled.div`
.otpVerifybutton{
    // width: 80%;
    height: 50px !important;
    background:#6B47F5;
    color:#fff;
    border:#6B47F5;
    font-size: 20px;
    letter-spacing: 1px;

    &:hover {
      background-color: #4F46E5;
      border-color: #4F46E5;
    }
  }
  .p-dialog-content{
    padding:20px;
    border-radius:10px;
  }
  .otpVerificationTitle{
    font-weight: 700;
    font-size: 36px;    
    text-transform: capitalize;   
    color: #6B47F5;
  }
  .otpSentMessageStyle{
    font-size: 18px;
    font-weight: 400;
    color: #4C565C;
    padding-top:15px;
    text-align:center;

  }
  .containerStyle{
    width:60px !important;
    height:60px;
    border: 1px solid #EAEAEA;
    border-radius: 10px !important; 
  }
  .countdownTextStyle {
    font-size: 18px;
    font-weight: 700;
    padding-top: 15px;
    text-align: center;
    padding-bottom: 15px;
}
.verifyButtonDiv{
    padding-top: 30px;
}
.resendOtp{
    padding-top: 30px;
    font-size: 18px;
    font-weight: 700;
    display:inline-block;
    width: 100%;
}

.countdownStyle{
   color:red;
}
.p-button.p-component.d-block.p-button-text.mx-auto.my-2 {
  margin: 0 5px !important;
  display: inline-block !important;
  padding: 0;
  text-decoration: underline;
}

`;

export default OtpPageWrapper;